<script lang="ts">
    import Icon from "../Icon.svelte"
    import { Datepicker } from "vanillajs-datepicker"
    import { _ } from "svelte-i18n"
    import { createEventDispatcher } from "svelte"
    import { tooltip } from "../../../helper"
    import { clickIsOutsideDateModal, datepickerLanguage } from "./helper"

    export let symbol,
        dateValue: Date,
        followUpState: "none" | "today" | "overdue" | "future",
        tooltipContent: string,
        hideAllModals: () => void,
        getElementPosition: (
            element: HTMLElement,
            options?: {
                minSpace: number
                offsetAbove: number
            }
        ) => { x: string; y: string }

    const dispatcher = createEventDispatcher()
    Datepicker.locales.en = datepickerLanguage
    let wrapper: HTMLElement, datepicker: typeof Datepicker

    function hideDateDeleteValidationModal() {
        const dateDeleteValidationModal = document.getElementById("dateDeleteValidationModal")
        dateDeleteValidationModal.style.display = "none"
        const bottom = dateDeleteValidationModal.querySelector(".bottom")
        bottom.removeEventListener("click", dateDeleteListener)
        document.removeEventListener("click", outSideDateDeleteClickListener)
    }
    function dateDeleteListener(e: any) {
        if ((e.target as Element).classList.contains("delete")) {
            dateValue = null
            dispatcher("update", dateValue)
        }
        hideDateDeleteValidationModal()
    }

    function approveShutdown() {
        const dateDeleteValidationModal = document.getElementById("dateDeleteValidationModal")
        if (dateDeleteValidationModal.style.display === "flex") return
        dateDeleteValidationModal.style.display = "flex"
        const bottom = dateDeleteValidationModal.querySelector(".bottom")
        dateDeleteValidationModal.style.top = getElementPosition(wrapper).y
        dateDeleteValidationModal.style.right = getElementPosition(wrapper).x
        bottom.addEventListener("click", dateDeleteListener)
        document.addEventListener("click", outSideDateDeleteClickListener)
    }

    function outSideDateDeleteClickListener(e: MouseEvent) {
        const dateDeleteValidationModal = document.getElementById("dateDeleteValidationModal")
        if (!dateDeleteValidationModal.contains(e.currentTarget as Node)) {
            hideDateDeleteValidationModal()
        }
    }

    function outSideDateModalClickListener(e: MouseEvent) {
        if (clickIsOutsideDateModal(e)) hideDatepicker()
    }
    function dateChangeListener(e: any) {
        dateValue = new Date(e.detail.date)
        hideDatepicker()
        dispatcher("update", dateValue)
    }

    function hideDatepicker() {
        const dateModal = document.getElementById("dateModal")
        dateModal.style.display = "none"
        datepicker?.destroy()

        dateModal.removeEventListener("changeDate", dateChangeListener)
        document.removeEventListener("click", outSideDateModalClickListener)
    }

    function showDatepicker() {
        let dateModal = document.getElementById("dateModal")
        hideAllModals()
        if (datepicker) hideDatepicker()
        dateModal = document.getElementById("dateModal")

        dateModal.style.display = "block"
        dateModal.style.top = getElementPosition(wrapper, { minSpace: 300, offsetAbove: 300 }).y
        dateModal.style.right = getElementPosition(wrapper, { minSpace: 300, offsetAbove: 300 }).x
        datepicker = new Datepicker(dateModal, {})

        if (dateValue) datepicker.setDate(dateValue)
        dateModal.addEventListener("changeDate", dateChangeListener)
        document.addEventListener("click", outSideDateModalClickListener)
    }
</script>

<style lang="less">
    @import "vanillajs-datepicker/css/datepicker.css";
    :global .hiddenscript {
        opacity: 0;
        position: absolute;
    }
    .custom-date-picker {
        flex-grow: 1;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
        &.twoChilds {
            justify-content: space-between;
        }
        .btn.icon,
        .btn.text {
            padding: 0px;
            height: 100%;
            font-size: 16px;
            display: flex;
            align-items: center;
            color: var(--renzrot);
            &::before {
                display: none;
            }
            &::after {
                display: none;
            }
        }
        .btn.text {
            color: var(--darkbg);
        }
        &.today {
            .btn.text,
            .btn.icon {
                color: var(--renzrot);
            }
        }
        &.overdue {
            .btn.text,
            .btn.icon {
                color: white;
            }
            .btn.text {
                text-decoration: line-through;
            }
        }
    }
</style>

<div class="custom-date-picker {dateValue ? 'twoChilds' : ''} {followUpState}" bind:this="{wrapper}">
    {#if dateValue}
        <button data-cy="custom-date-picker-text" class="btn text" on:click="{showDatepicker}">
            {new Date(dateValue).toLocaleDateString("de-DE")}
        </button>
    {/if}
    {#if symbol}
        <button
            data-cy="custom-date-picker-icon"
            class="btn icon {dateValue ? 'dateset' : ''}"
            use:tooltip="{{ content: tooltipContent }}"
            on:click="{() => {
                hideAllModals()
                if (dateValue) approveShutdown()
                else showDatepicker()
            }}"
        >
            <Icon path="{symbol}" width="24px" height="24px" />
        </button>
    {/if}
</div>
